
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/RangeSlider.html",
      function () {
        return require("private-next-pages/Forms/RangeSlider.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/RangeSlider.html"])
      });
    }
  